import { z } from "zod/v4";

import { CampaignWithIdSchema } from "../../../dtos/deprecated/campaigns";

export const PatchCampaignRequestBodySchema = CampaignWithIdSchema.partial()
  .omit({
    discount: true,
    userInterfaces: true,
  })
  .extend({ id: z.uuid() });
export type PatchCampaignRequestBodyType = z.infer<
  typeof PatchCampaignRequestBodySchema
>;

export const PatchCampaignRequestPathParamSchema = z.object({
  campaignId: z.uuid(),
});

export type PatchCampaignRequestPathParamType = z.infer<
  typeof PatchCampaignRequestPathParamSchema
>;

export const PatchCampaignResponseBodySchema = z.object({
  campaign: CampaignWithIdSchema,
});

export type PatchCampaignResponseBodyType = z.infer<
  typeof PatchCampaignResponseBodySchema
>;
